import { render, staticRenderFns } from "./OnboardingUISettingsContent.vue?vue&type=template&id=0423352a&scoped=true&lang=pug"
import script from "./OnboardingUISettingsContent.vue?vue&type=script&lang=ts"
export * from "./OnboardingUISettingsContent.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingUISettingsContent.vue?vue&type=style&index=0&id=0423352a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0423352a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VFadeTransition,VIcon,VRadio,VRadioGroup,VRow})
